import React from 'react';
import Image from 'next/image';
import { useTheme } from 'next-themes';
import Skeleton from 'react-loading-skeleton';

import { ActiveLink, Button } from '@/ui/index';
import { ETheme } from '@/enums/theme';

import styles from './Campaign.module.scss';

const Campaign = ({ data, href }) => {
  const { theme } = useTheme();
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  return (
    <div
      className={styles.newsItem}
      itemScope
      itemType='https://schema.org/NewsArticle'
    >
      <ActiveLink href={`${href ? `/${href}` : ''}/${data?.slug}`}>
        <a
          title={data?.title}
          aria-label={data?.title}
          className={styles.imageContainer}
        >
          {!isImageLoaded && <Skeleton width='100%' height='100%' />}
          <Image
            src={data?.image}
            alt={data?.title}
            title={data?.title}
            layout='fill'
            loading='lazy'
            onLoadingComplete={() => setIsImageLoaded(true)}
            style={{
              visibility: isImageLoaded ? 'visible' : 'hidden',
            }}
          />
        </a>
      </ActiveLink>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <span className={styles.title}>{data?.title}</span>
          <span className={styles.description}>{data?.text}</span>
        </div>
        <div className={styles.link}>
          <Button
            Component={'router'}
            variant={'text'}
            href={`${href ? `/${href}` : ''}/${data?.slug}`}
            className={styles.goToPost}
          >
            {data?.link_text}{' '}
            <div className={styles.arrow}>
              {!isImageLoaded && (
                <Skeleton
                  width={16}
                  height={16}
                  style={{ position: 'absolute', top: '24px' }}
                />
              )}
              <Image
                src={
                  theme === ETheme.LIGHT_MODE
                    ? '/assets/ArrowRightLight.svg'
                    : '/assets/ArrowRightDark.svg'
                }
                alt='arrow'
                title='arrow'
                width={16}
                height={16}
                onLoadingComplete={() => setIsImageLoaded(true)}
                style={{
                  visibility: isImageLoaded ? 'visible' : 'hidden',
                }}
              />
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
